import { useEffect, useState } from 'react'
import BaseInput from '../../../../components/BasicComponent/BaseInput'
import BaseButton from '../../../../components/BasicComponent/BaseButton'
import BaseTitle from '../../../../components/BasicComponent/BaseTitle'
import { LoadingOutlined } from '@ant-design/icons'
import appUserService from '../../../../services/appUserService'
import { getReferUserIdFromReferUserCode } from '../../../../helper/referralParams'
import { useAppParamsContext } from '../../../../context/AppParamsContext'
import './index.scss'

export default function ReferralCodeInput({ onReferralValidated }) {
  const { referUserCode: defaultReferUserCode } = useAppParamsContext()
  const [referUserCode, setReferUserCode] = useState(defaultReferUserCode || '')
  const [isApplyingReferUserCode, setIsApplyingReferUserCode] = useState(false)
  const [referUserCodeErrorMessage, setReferUserCodeErrorMessage] = useState('')
  const [referUserCodeMessage, setReferUserCodeMessage] = useState('')

  useEffect(() => {
    if (defaultReferUserCode) {
      setReferUserCode(defaultReferUserCode)
    }
  }, [defaultReferUserCode])

  const validateAndGetReferUserId = async (code) => {
    const parsedId = getReferUserIdFromReferUserCode(code)
    
    if (parsedId == null) {
      return { isReferUserCodeValid: false }
    }

    try {
      const checkResult = await appUserService.checkExistReferUserId({ referUserId: parsedId })
      if (checkResult.statusCode === 200 && checkResult.data?.isExist) {
        return { isReferUserCodeValid: true, referUserId: parsedId }
      }
      return { isReferUserCodeValid: false }
    } catch (error) {
      return { isReferUserCodeValid: false }
    }
  }

  const onApplyReferUserCode = async () => {
    setReferUserCodeErrorMessage('')
    setReferUserCodeMessage('')

    if (!referUserCode) {
      setReferUserCodeErrorMessage('Vui lòng nhập mã giới thiệu')
      if (onReferralValidated) onReferralValidated({ referUserCode: null, referUserId: null })
      return
    }

    setIsApplyingReferUserCode(true)
    try {
      const { isReferUserCodeValid, referUserId: parsedId } = await validateAndGetReferUserId(referUserCode)

      if (isReferUserCodeValid) {
        setReferUserCodeMessage('Mã giới thiệu hợp lệ')
        if (onReferralValidated) onReferralValidated({ referUserCode: referUserCode, referUserId: parsedId })
      } else {
        setReferUserCodeErrorMessage('Mã giới thiệu không hợp lệ!')
        if (onReferralValidated) onReferralValidated({ referUserCode: null, referUserId: null })
      }
    } finally {
      setIsApplyingReferUserCode(false)
    }
  }

  const handleChange = (e) => {
    let value = e.target.value.trim()
    setReferUserCode(value)
    setReferUserCodeErrorMessage('')
    setReferUserCodeMessage('')
    // When the user changes the code, clear the previously validated code in the parent
    if (onReferralValidated) onReferralValidated({ referUserCode: null, referUserId: null })
  }

  return (
    <div className="ReferralCodeInput">
      <BaseTitle>Mã giới thiệu (nếu có)</BaseTitle>
      <div className="ReferralCodeInput_inputRow">
        <BaseInput
          className="ReferralCodeInput_inputBox"
          value={referUserCode}
          onChange={handleChange}
          placeholder="Nhập mã giới thiệu"
          showClear={Boolean(referUserCode)}
          onClear={() => {
            setReferUserCode('')
            setReferUserCodeErrorMessage('')
            setReferUserCodeMessage('')
            if (onReferralValidated) onReferralValidated({ referUserCode: null, referUserId: null })
          }}
          error={referUserCodeErrorMessage}
          success={referUserCodeMessage}
        />
        <BaseButton
          type="right"
          className="ReferralCodeInput_applyBtn"
          onClick={onApplyReferUserCode}
          disabled={!referUserCode || isApplyingReferUserCode}
        >
          {isApplyingReferUserCode ? <LoadingOutlined /> : 'Áp dụng'}
        </BaseButton>
      </div>
    </div>
  )
}
